import React, { useState, useRef } from 'react';
import { X, Bot, User, ExternalLink, Mic } from 'lucide-react';

interface ChatbotModalProps {
  isOpen: boolean;
  onClose: () => void;
}

interface Message {
  id: string;
  text?: string;
  audioUrl?: string;
  isBot: boolean;
  timestamp: Date;
  isLink?: boolean;
  linkUrl?: string;
}

export function ChatbotModal({ isOpen, onClose }: ChatbotModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white dark:bg-gray-800 rounded-lg w-full max-w-md h-[340px] flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-gray-200 dark:border-gray-700">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-sky-100 dark:bg-sky-900/20 rounded-full flex items-center justify-center">
              <Bot className="w-6 h-6 text-sky-600 dark:text-sky-400" />
            </div>
            <div>
              <h3 className="font-semibold text-gray-900 dark:text-white">
                Asistente Virtual
              </h3>
              <p className="text-xs text-green-500">En línea</p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="p-1 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Mensaje único */}
        <div className="flex-1 flex flex-col items-center justify-center px-8 py-10 bg-gradient-to-br from-sky-50/60 via-white/80 to-indigo-50/60 dark:from-sky-900/20 dark:via-gray-900/60 dark:to-indigo-900/20">
          <div className="bg-gradient-to-br from-sky-400/20 to-indigo-400/20 rounded-full w-20 h-20 flex items-center justify-center mb-6 shadow-inner animate-pulse">
            <Bot className="w-10 h-10 text-primary dark:text-sky-300" />
          </div>
          <div className="text-center">
            <p className="text-2xl font-extrabold text-sky-700 dark:text-sky-200 mb-2 drop-shadow-sm">
              ¡Ya casi!
            </p>
            <p className="text-base text-gray-700 dark:text-gray-200 font-medium leading-relaxed">
              Pronto podrás charlar con nuestra <span className="text-primary font-bold">IA</span>.<br />
              <span className="text-indigo-500 font-semibold">Seguinos en redes</span> para enterarte de esto y mucho más.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}